// extracted by mini-css-extract-plugin
export default {"form":"GS8k1","mutedText":"GKsib","submitContainer":"v98qJ","submitBtn":"bpzn9","shakeError":"Xp8NN","shake":"AnOHl","submitHint":"SETt0","modal":"h66Ky"};